'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListRestrictedDomains$() {
}
export { $c_Lpresto_ListRestrictedDomains$ as $c_Lpresto_ListRestrictedDomains$ };
$p = $c_Lpresto_ListRestrictedDomains$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListRestrictedDomains$;
/** @constructor */
function $h_Lpresto_ListRestrictedDomains$() {
}
export { $h_Lpresto_ListRestrictedDomains$ as $h_Lpresto_ListRestrictedDomains$ };
$h_Lpresto_ListRestrictedDomains$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 1192670774;
});
$p.l = (function() {
  return "ListRestrictedDomains";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "ListRestrictedDomains";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dm = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().qm);
});
var $d_Lpresto_ListRestrictedDomains$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListRestrictedDomains$, "presto.ListRestrictedDomains$", ({
  LE: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_ListRestrictedDomains$ as $d_Lpresto_ListRestrictedDomains$ };
var $n_Lpresto_ListRestrictedDomains$;
function $m_Lpresto_ListRestrictedDomains$() {
  if ((!$n_Lpresto_ListRestrictedDomains$)) {
    $n_Lpresto_ListRestrictedDomains$ = new $c_Lpresto_ListRestrictedDomains$();
  }
  return $n_Lpresto_ListRestrictedDomains$;
}
export { $m_Lpresto_ListRestrictedDomains$ as $m_Lpresto_ListRestrictedDomains$ };
//# sourceMappingURL=presto.-List-Restricted-Domains$.js.map
